import Image from "next/image";

interface LoadingAnalysisProps {
  isLoading: boolean;
}

export default function LoadingAnalysis({ isLoading }: LoadingAnalysisProps) {
  if (!isLoading) return null;

  return (
    <>
      <div className="relative opacity-0">
        <p>loading</p>
      </div>
      <div className="absolute -top-14">
        <Image
          src={"/image/paw/paw.svg"}
          alt={"paw"}
          height={55}
          width={55}
          className="h-auto w-auto animate-ping"
        />
      </div>
    </>
  );
}
